export type MapType =
  | 'DISPLAY_APPOINTMENTS_TIME'
  | 'DISPLAY_FITTER'
  | 'DISPLAY_FITTERS_MARK';
